import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Card } from "antd";

export function SortableCard({
  id,
  children,
  className,
  bodyStyle,
  style,
  dragDisabled = false,
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id, disabled: dragDisabled });
  const mergedStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    cursor: dragDisabled ? "default" : isDragging ? "grabbing" : "grab",
    ...style,
  };
  return (
    <Card
      ref={setNodeRef}
      {...attributes}
      {...(dragDisabled ? {} : listeners)}
      className={className}
      data-id={id}
      size="small"
      styles={{ body: bodyStyle }}
      style={mergedStyle}
    >
      {children}
    </Card>
  );
}